import { useEffect } from 'react';
import { sendYandexEvent } from 'common/utils/index';
import { useUser } from 'store/features/auth/selectors/user';
import { useIsAllowDependsOnContour } from 'entities/application';

const useSendYandexEvents = () => {
  const { clientCode = '', userType = ''  } = useUser() || {};
  const isAllowDependsOnContour = useIsAllowDependsOnContour();

  useEffect(() => {
    if (isAllowDependsOnContour && clientCode) {
      sendYandexEvent('setUserID', clientCode);
      sendYandexEvent('userParams', { userType });
    };
  }, [clientCode, userType, isAllowDependsOnContour]);
};

export default useSendYandexEvents;
